import apiClient from './apiClient';
import axios from 'axios';
import apiConfig from '../config/apiConfig';
import { captureException } from '../utils/errorTracking';

export const addBookmark = async (articleId) => {
  try {
    const response = await apiClient.post('/bookmarks', { articleId });
    return response.data;
  } catch (error) {
    captureException(error, {
      tags: { service: 'bookmarkService', action: 'addBookmark', articleId },
    });
    throw error;
  }
};

export const removeBookmark = async (articleId) => {
  try {
    const response = await apiClient.delete(`/bookmarks/${articleId}`);
    return response.data;
  } catch (error) {
    captureException(error, {
      tags: { service: 'bookmarkService', action: 'removeBookmark', articleId },
    });
    throw error;
  }
};

export const getBookmarks = async (params = {}) => {
  try {
    const response = await apiClient.get('/bookmarks', { params });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      return { success: false, data: [] };
    }
    captureException(error, {
      tags: { service: 'bookmarkService', action: 'getBookmarks' },
    });
    throw error;
  }
};

export const checkBookmark = async (articleId) => {
  try {
    const response = await apiClient.get(`/bookmarks/check/${articleId}`);
    return response.data;
  } catch (error) {
    captureException(error, {
      tags: { service: 'bookmarkService', action: 'checkBookmark', articleId },
    });
    return { success: false, isBookmarked: false };
  }
};

export const getBookmarkCount = async (articleId) => {
  try {
    const response = await axios.get(`${apiConfig.BASE_URL}/bookmarks/count/${articleId}`);
    return response.data;
  } catch (error) {
    captureException(error, {
      tags: { service: 'bookmarkService', action: 'getBookmarkCount', articleId },
    });
    return { success: false, count: 0 };
  }
};
